/*
* @Author: MiheevAV
* @Date:   2020-05-10 14:42:01
* @Last Modified by:   MiheevAV
* @Last Modified time: 2020-05-11 11:12:34
*/

export function preload() {
  var loader = preloader({
    xhrImages: false
  });

  loader.addImage('/img/logo.svg');
  loader.addImage('/img/arrows/-1.svg');
  loader.addImage('/img/weather/animated/cloudy-day-1.svg');
  loader.addImage('/img/weather/animated/cloudy-day-2.svg');
  loader.addImage('/img/weather/animated/cloudy-day-3.svg');
  loader.addImage('/img/weather/animated/cloudy-night-1.svg');
  loader.addImage('/img/weather/animated/cloudy-night-2.svg');
  loader.addImage('/img/weather/animated/cloudy-night-3.svg');
  loader.addImage('/img/weather/animated/cloudy.svg');
  loader.addImage('/img/weather/animated/day.svg');
  loader.addImage('/img/weather/animated/night.svg');
  loader.addImage('/img/weather/animated/rainy-1.svg');
  loader.addImage('/img/weather/animated/rainy-2.svg');
  loader.addImage('/img/weather/animated/rainy-3.svg');
  loader.addImage('/img/weather/animated/rainy-4.svg');
  loader.addImage('/img/weather/animated/rainy-5.svg');
  loader.addImage('/img/weather/animated/rainy-6.svg');
  loader.addImage('/img/weather/animated/rainy-7.svg');
  loader.addImage('/img/weather/animated/snowy-1.svg');
  loader.addImage('/img/weather/animated/snowy-2.svg');
  loader.addImage('/img/weather/animated/snowy-3.svg');
  loader.addImage('/img/weather/animated/snowy-4.svg');
  loader.addImage('/img/weather/animated/snowy-5.svg');
  loader.addImage('/img/weather/animated/snowy-6.svg');
  loader.addImage('/img/weather/animated/thunder.svg');
  loader.addImage('/img/weather/animated/weather.svg');
  loader.load();

}

/**
 * Set upperCase first elem from sring
 * @param  string str  "asd"
 * @return string     "Asd"
 */
export function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
